import { apiGet, apiPost } from '@/services/api/baseService';

export type VersionBump = 'patch' | 'minor' | 'major';

export interface ProductReleaseNote {
  textSv: string;
  textEn: string;
}

export interface ProductRelease {
  id: number;
  version: string;
  bump: VersionBump;
  releasedOn: string;
  status: 'released' | 'current' | 'upcoming';
  title: string;
  summarySv: string;
  summaryEn: string;
  notes: ProductReleaseNote[];
}

export interface ReleaseList {
  currentVersion: string | null;
  releases: ProductRelease[];
}

export interface ReleaseSuggestion {
  currentVersion: string;
  suggestedBump: VersionBump;
  versions: Record<VersionBump, string>;
  pendingCount: number;
  pendingByBump: Record<VersionBump, number>;
}

export interface CreateReleaseInput {
  bump: VersionBump;
  releasedOn: string;
  title: string;
  summarySv: string;
  summaryEn: string;
  notes: ProductReleaseNote[];
  confirmLower?: boolean;
}

export const productReleaseApi = {
  list(): Promise<ReleaseList> {
    return apiGet<ReleaseList>('/api/version/releases');
  },

  suggestion(): Promise<ReleaseSuggestion> {
    return apiGet<ReleaseSuggestion>('/api/version/releases/suggestion');
  },

  create(input: CreateReleaseInput): Promise<ProductRelease> {
    return apiPost<ProductRelease>('/api/version/releases', input);
  },
};
